import "./LoginPage.css";

import { useState } from "react";

import { login } from "../../features/userSlice";
import { useDispatch } from "react-redux";
import { loginUser } from "../../services/auth";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const { data, status } = await loginUser(email, password);
      sessionStorage.setItem("user", data.token);
      dispatch(login(data.token));
    } catch (error) {
      console.error(error.message);
    }
    setEmail("");
    setPassword("");
  };

  return (
    <div className="login-page">
      <h1>Login strana</h1>
      <form className="loginForm" onSubmit={handleLogin}>
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit">Log in</button>
      </form>
    </div>
  );
};

export default LoginPage;
